import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { getBrands } from '../../../../actions/common'

// Utils
import { translation } from '../../../../utils/helpers'

// Components
import DropDown from '../../../elements/dropDown'

class Brand extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isGettingBrands: false
    }
  }

  componentDidMount () {
    if (this.props.brands && this.props.brands.length > 0) {
      this.props.updateState({
        BrandOriginal: this.props.brands[0].Name
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.isGettingBrands) return

    if (this.props.brands === undefined || this.props.brands === null || this.props.brands.length === 0) {
      this.setState({
        isGettingBrands: true
      }, () => {
        this.props.getBrands().then((res) => {
          this.setState({
            isGettingBrands: false
          })
        })
      })
    }
  }

  renderOptions () {
    return this.props.brands.map((brand, key) => {
      return <option value={brand.Name} key={key}>{translation(brand.Name)}</option>
    })
  }

  render () {
    return (
      <DropDown
        labelText={translation('145')}
        name='BrandOriginal'
        value={this.props.selected}
        onChange={this.props.onInputChange} >
        {this.renderOptions()}
      </DropDown>
    )
  }
}

Brand.propTypes = {
  selected: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  updateState: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    brands: state.common.brands
  }
}

export default connect(mapStateToProps, {
  getBrands
})(Brand)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/Brand/index.js